
import Video from './Video'
import Relation from './Relation'
import Gallery from './Gallery'
import Footer from './Footer'
import './main.css'
import UserAppContext from '../../hook/UserAppContext'

const Main = () => {

      const {user, dataApp} = UserAppContext()
      const {relation, videos, galleries} = user.user 

      return (
            <div className="main_wrapper">
                  <Relation relation={relation} data={dataApp} />
                  <Video videos={videos} />
                  <Gallery galleries={galleries} />
                  <Footer />
            </div>
      )
}

export default Main